import { DEVICE_CODE } from './device-code'

export const TRACKVISION_CHANNEL_DEFAULT_KEY = 0
export const TRACKVISION_CHANNEL_MAPPING = {
  CONCOX: {
    ADAS: {
      [TRACKVISION_CHANNEL_DEFAULT_KEY]: 1,
      [DEVICE_CODE.CONCOX.JC400_D]: 1,
    },
    DMS: {
      [TRACKVISION_CHANNEL_DEFAULT_KEY]: 2,
      [DEVICE_CODE.CONCOX.JC400_D]: 2,
      [DEVICE_CODE.CONCOX.JC261]: 2,
    },
  },
  BSJ: {
    ADAS: {
      [TRACKVISION_CHANNEL_DEFAULT_KEY]: 1,
      [DEVICE_CODE.BSJ.GH03T]: 1,
      [DEVICE_CODE.BSJ.MDVR]: 2,
      [DEVICE_CODE.BSJ.MDVR08]: 2,
    },
    DMS: {
      [TRACKVISION_CHANNEL_DEFAULT_KEY]: 3,
      [DEVICE_CODE.BSJ.GH03T]: 3,
      [DEVICE_CODE.BSJ.MDVR]: 1,
      [DEVICE_CODE.BSJ.MDVR08]: 1,
    },
  },
  VSS_HOWEN: {
    ADAS: { [TRACKVISION_CHANNEL_DEFAULT_KEY]: 1 },
    DMS: {
      [TRACKVISION_CHANNEL_DEFAULT_KEY]: 3,
      [DEVICE_CODE.VSS_HOWEN.VSS_ME3108]: 2,
      [DEVICE_CODE.VSS_HOWEN.VSS_MC3001]: 2,
    },
  },
}
